import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ImageGalleryItem } from '@shared/models/image-gallery-item';

@Component({
	selector: 'app-image-gallery-dialog',
	templateUrl: './image-gallery-dialog.component.html',
	styleUrls: ['./image-gallery-dialog.component.css']
})
export class ImageGalleryDialogComponent implements OnInit {

	constructor(
		public dialogRef: MatDialogRef<ImageGalleryDialogComponent>,
		@Inject(MAT_DIALOG_DATA) public items: ImageGalleryItem[]) { }

	ngOnInit(): void {
		// console.log('dialog, data', this.items);
	}

	selectedItem?: ImageGalleryItem;

	private clickTime = Date.now();
	selectItem(item: ImageGalleryItem): void {
		this.selectedItem = item;

		const now = Date.now();
		if (now - this.clickTime < 500) {
			// let's consider it a double-click
			this.dialogOk();
		}
		else {
			this.clickTime = now;
		}
	}

	dialogOk() {
		this.dialogRef.close(this.selectedItem);
	}

	dialogCancel(): void {
		this.dialogRef.close();
	}
}
